// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6ElLm","title":"Header_title__tW1Nh","logo":"Header_logo__tFOZh"};